import React from 'react';
import { ClaroModalCardOk } from "@claropay/shared";

const ModalCardOk = ({ 
    isOpen, 
    text, 
    buttontext, 
    textdetail,
    onclickModal,
    textLink,
    onClickImg,
    fontSizeDetail,
    srcImage,
    textSizeLinkButton,
    fontSizeTitle,
    heightImg,
    widthImg,
    imageMargin,
    fontFamilyTitle,
    colorTextModal1,
    marginTitle,
    widthButton,
    marginButton,
    paddingCard,
    fontFamilyButton,
    colorButton,
    backgroundColorButton,
    fontSizeButton,
    fontWeightTitle,    
    fontFamilyTextdetail,   
    colorTextdetail,    
    marginTextDetail,    
    textColorLinkButton,
    fontFamilyLinkButton,
    heightButton,
    paddingButton
}) => {
    return(
        <ClaroModalCardOk
            isOpen={isOpen}
            fontSizeTitle={fontSizeTitle}
            backgroundColor="rgba(0,0,0,0.10)"
            borderRadiusCard="5px"
            fontFamilyTitle={fontFamilyTitle ? fontFamilyTitle : "Amx-Regular"}
            heightImg={heightImg ? heightImg : "62px"}
            widthImg={widthImg ? widthImg : "62px"}
            backgroundColorButton={backgroundColorButton ? backgroundColorButton : "#202020"}
            height="100%"
            textDecorationLinkButton="underline"
            textAlignLinkButton="center"
            textTransformLinkButton="initial"
            widthLinkButton="100%"
            fontWeightLinkButton="bold"
            srcImage={srcImage}
            text= {text}
            fontSizeDetail={fontSizeDetail}
            buttontext={buttontext}
            textdetail={textdetail}
            onclickModal={onclickModal}
            onClickImg = {onClickImg}
            textLink={textLink}
            textSizeLinkButton={ textSizeLinkButton }
            imageMargin={imageMargin}
            colorTextModal1={colorTextModal1}
            marginTitle={marginTitle}
            widthButton={widthButton}
            marginButton={marginButton}
            paddingCard={paddingCard}
            fontFamilyButton={fontFamilyButton}
            colorButton={colorButton}
            fontSizeButton={fontSizeButton}
            fontWeightTitle={fontWeightTitle}
            fontFamilyTextdetail={fontFamilyTextdetail}
            colorTextdetail={colorTextdetail}
            marginTextDetail={marginTextDetail}
            textColorLinkButton={textColorLinkButton}
            fontFamilyLinkButton={fontFamilyLinkButton}
            heightButton={"auto"}
            paddingButton={paddingButton}
        />
    )
}
export default ModalCardOk;





